<ng-container [formGroup]="paramGroup">
    <h4 mat-dialog-title>
        <span i18n="@@c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b" t="c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
            >Characteristic</span
        >
        <i>{{ translate.get(data.param.typeName) }}</i>
    </h4>

    <div class="grid">
        <tsl-form-field>
            <tsl-label
                for="parameterValue"
                i18n="@@5049e204c14c648691ac775a64fb504467aeb549"
                t="5049e204c14c648691ac775a64fb504467aeb549"
                >Value</tsl-label
            >
            <input
                id="parameterValue"
                tslInput
                fullWidth
                maxlength="50"
                shape="rectangle"
                formControlName="paramValue"
            />
            <tsl-error *ngIf="paramValue.invalid" i18n="@@Required" t="Required">Required</tsl-error>
        </tsl-form-field>
    </div>

    <div class="right">
        <button tsl-button outline color="black" size="small" (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button
            tsl-button
            filled
            color="black"
            size="small"
            [disabled]="paramGroup.invalid"
            (click)="onSave()"
            i18n="@@f6755cff4957d5c3c89bafce5651f1b6fa2b1fd9"
            t="f6755cff4957d5c3c89bafce5651f1b6fa2b1fd9"
            >Add</button
        >
    </div>
</ng-container>
